import { Controller } from "@hotwired/stimulus"

// Curtain reveal: title acts as a trigger, content slides out from behind it
export default class extends Controller {
  static targets = ["trigger", "panel", "content", "card", "indicator", "line", "label"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    this.panelTarget.style.display = "grid"
    this.panelTarget.style.gridTemplateRows = "0fr"
    this.panelTarget.style.transition = "grid-template-rows 0.6s cubic-bezier(0.22, 1, 0.36, 1)"
    this.contentTarget.style.overflow = "hidden"

    // Store original label text for toggle
    if (this.hasLabelTarget) {
      this._openLabel = this.labelTarget.dataset.openLabel || this.labelTarget.textContent.replace("Voir", "Masquer")
      this._closedLabel = this.labelTarget.textContent
    }
  }

  toggle() {
    this.openValue = !this.openValue
    this._update()
  }

  _update() {
    const open = this.openValue

    // Panel expand/collapse
    this.panelTarget.style.gridTemplateRows = open ? "1fr" : "0fr"

    // Rotating bar indicator (90° when open)
    if (this.hasIndicatorTarget) {
      this.indicatorTarget.style.transform = open ? "rotate(90deg)" : "rotate(0deg)"
      this.indicatorTarget.style.opacity = open ? "0.8" : "0.4"
    }

    // Label text swap
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = open ? this._openLabel : this._closedLabel
    }

    // Trigger styling
    if (this.hasTriggerTarget) {
      if (open) {
        this.triggerTarget.classList.add("text-orange-600", "border-orange-200")
        this.triggerTarget.classList.remove("text-gray-400", "border-gray-200")
      } else {
        this.triggerTarget.classList.remove("text-orange-600", "border-orange-200")
        this.triggerTarget.classList.add("text-gray-400", "border-gray-200")
      }
    }

    // Line color
    if (this.hasLineTarget) {
      this.lineTargets.forEach((line) => {
        if (open) {
          line.classList.add("via-orange-200")
          line.classList.remove("via-gray-200")
        } else {
          line.classList.remove("via-orange-200")
          line.classList.add("via-gray-200")
        }
      })
    }

    // Staggered card reveal
    if (this.hasCardTarget) {
      this.cardTargets.forEach((card, i) => {
        if (open) {
          card.style.transition = `opacity 0.5s ease ${100 + i * 70}ms, transform 0.5s cubic-bezier(0.22, 1, 0.36, 1) ${100 + i * 70}ms`
          card.style.opacity = "1"
          card.style.transform = "translateY(0)"
        } else {
          card.style.transition = "opacity 0.25s ease, transform 0.25s ease"
          card.style.opacity = "0"
          card.style.transform = "translateY(16px)"
        }
      })
    }
  }
}
